// Vehicle Makes and Models Data for WOW AUTOBODY
// Organized by manufacturer with popular models

export const vehicleMakes = [
  { value: "acura", label: "Acura" },
  { value: "audi", label: "Audi" },
  { value: "bmw", label: "BMW" },
  { value: "buick", label: "Buick" },
  { value: "cadillac", label: "Cadillac" },
  { value: "chevrolet", label: "Chevrolet" },
  { value: "chrysler", label: "Chrysler" },
  { value: "dodge", label: "Dodge" },
  { value: "ford", label: "Ford" },
  { value: "gmc", label: "GMC" },
  { value: "honda", label: "Honda" },
  { value: "hyundai", label: "Hyundai" },
  { value: "infiniti", label: "Infiniti" },
  { value: "jeep", label: "Jeep" },
  { value: "kia", label: "Kia" },
  { value: "lexus", label: "Lexus" },
  { value: "lincoln", label: "Lincoln" },
  { value: "mazda", label: "Mazda" },
  { value: "mercedes", label: "Mercedes-Benz" },
  { value: "mitsubishi", label: "Mitsubishi" },
  { value: "nissan", label: "Nissan" },
  { value: "ram", label: "RAM" },
  { value: "subaru", label: "Subaru" },
  { value: "tesla", label: "Tesla" },
  { value: "toyota", label: "Toyota" },
  { value: "volkswagen", label: "Volkswagen" },
  { value: "volvo", label: "Volvo" },
  { value: "other", label: "Other" }
];

export const vehicleModels = {
  acura: [
    "ILX", "Integra", "MDX", "NSX", "RDX", "TLX"
  ],
  audi: [
    "A3", "A4", "A5", "A6", "A7", "A8", "e-tron", "Q3", "Q5", "Q7", "Q8", "RS3", "RS5", "S4", "S5", "TT"
  ],
  bmw: [
    "2 Series", "3 Series", "4 Series", "5 Series", "7 Series", "8 Series", "i4", "iX", "M3", "M4", "M5", "X1", "X3", "X5", "X6", "X7", "Z4"
  ],
  buick: [
    "Enclave", "Encore", "Encore GX", "Envision"
  ],
  cadillac: [
    "CT4", "CT5", "Escalade", "Lyriq", "XT4", "XT5", "XT6"
  ],
  chevrolet: [
    "Blazer", "Bolt", "Camaro", "Colorado", "Corvette", "Equinox", "Malibu", "Silverado", "Suburban", "Tahoe", "Trailblazer", "Traverse", "Trax"
  ],
  chrysler: [
    "300", "Pacifica", "Voyager"
  ],
  dodge: [
    "Challenger", "Charger", "Durango", "Hornet"
  ],
  ford: [
    "Bronco", "Bronco Sport", "Edge", "Escape", "Expedition", "Explorer", "F-150", "F-250", "F-350", "Maverick", "Mustang", "Mustang Mach-E", "Ranger"
  ],
  gmc: [
    "Acadia", "Canyon", "Hummer EV", "Sierra 1500", "Sierra 2500", "Terrain", "Yukon"
  ],
  honda: [
    "Accord", "Civic", "CR-V", "HR-V", "Insight", "Odyssey", "Passport", "Pilot", "Ridgeline"
  ],
  hyundai: [
    "Elantra", "Ioniq 5", "Ioniq 6", "Kona", "Palisade", "Santa Cruz", "Santa Fe", "Sonata", "Tucson", "Venue"
  ],
  infiniti: [
    "Q50", "Q60", "QX50", "QX55", "QX60", "QX80"
  ],
  jeep: [
    "Cherokee", "Compass", "Gladiator", "Grand Cherokee", "Grand Wagoneer", "Renegade", "Wagoneer", "Wrangler"
  ],
  kia: [
    "Carnival", "EV6", "Forte", "K5", "Niro", "Seltos", "Sorento", "Soul", "Sportage", "Stinger", "Telluride"
  ],
  lexus: [
    "ES", "GX", "IS", "LC", "LS", "LX", "NX", "RC", "RX", "RZ", "TX", "UX"
  ],
  lincoln: [
    "Aviator", "Corsair", "Nautilus", "Navigator"
  ],
  mazda: [
    "CX-30", "CX-5", "CX-50", "CX-9", "CX-90", "Mazda3", "Mazda6", "MX-5 Miata"
  ],
  mercedes: [
    "A-Class", "C-Class", "CLA", "CLS", "E-Class", "EQB", "EQE", "EQS", "G-Class", "GLA", "GLB", "GLC", "GLE", "GLS", "S-Class"
  ],
  mitsubishi: [
    "Eclipse Cross", "Mirage", "Outlander", "Outlander Sport"
  ],
  nissan: [
    "Altima", "Armada", "Ariya", "Frontier", "Kicks", "LEAF", "Maxima", "Murano", "Pathfinder", "Rogue", "Sentra", "Titan", "Versa", "Z"
  ],
  ram: [
    "1500", "2500", "3500", "ProMaster"
  ],
  subaru: [
    "Ascent", "BRZ", "Crosstrek", "Forester", "Impreza", "Legacy", "Outback", "Solterra", "WRX"
  ],
  tesla: [
    "Model 3", "Model S", "Model X", "Model Y", "Cybertruck"
  ],
  toyota: [
    "4Runner", "86", "bZ4X", "Camry", "Corolla", "Crown", "GR86", "GR Supra", "Grand Highlander", "Highlander", "Prius", "RAV4", "Sequoia", "Sienna", "Tacoma", "Tundra", "Venza"
  ],
  volkswagen: [
    "Arteon", "Atlas", "Atlas Cross Sport", "Golf", "GTI", "ID.4", "Jetta", "Taos", "Tiguan"
  ],
  volvo: [
    "C40", "S60", "S90", "V60", "V90", "XC40", "XC60", "XC90"
  ],
  other: [
    "Other - Please specify in description"
  ]
};

// Helper function to get models for a specific make
export const getModelsForMake = (make) => {
  return vehicleModels[make] || [];
};
